import { render, staticRenderFns } from "./Passo1.vue?vue&type=template&id=76c32c98"
import script from "./Passo1.vue?vue&type=script&lang=js"
export * from "./Passo1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports